module.exports = __webpack_public_path__ + "media/images/top/card-proposal-7f801df4c11a2acb9f3b529391485327.jpg";